import './MultiSelectDropdown.scss';

import { AntdOptionType } from '@sonar-software/sonar-ts-types';
import { caseInsensitiveContainsFilterOption } from '@lib/filter';
import { COPY_SPECIFIC } from '@sonar-software/sonar-ts-constants';
import { FilterDropdownProps } from 'antd/es/table/interface';
import { getDirectParent } from '@lib/popups';
import { RenderDOMFunc } from 'rc-select/lib/interface';

import { Button, Col, Row, Select } from 'antd';
import React, { PropsWithChildren } from 'react';

export interface MultiSelectDropdownProps extends FilterDropdownProps {
	getPopupContainer?: RenderDOMFunc;
	options: AntdOptionType[];
}

export const MultiSelectDropdown: React.FC<PropsWithChildren<MultiSelectDropdownProps>> = ({
	children,
	getPopupContainer = getDirectParent,
	selectedKeys,
	setSelectedKeys,
	confirm,
	options,
	visible
}) => {
	if (!visible) {
		return null;
	}

	const popupRender = (menu: React.ReactNode) =>
		<>
			{ menu }
			{ children }
			<Row
				className='filter-buttons'
				justify='space-between'>
				<Col>
					<Button
						disabled={ !selectedKeys.length }
						onClick={ () => {
							setSelectedKeys([]);
							confirm();
						} }
						size='small'
						type='link'>
						{ COPY_SPECIFIC.RESET }
					</Button>
				</Col>
				<Col>
					<Button
						onClick={ () => confirm() }
						size='small'
						type='primary'>
						{ COPY_SPECIFIC.OK }
					</Button>
				</Col>
			</Row>
		</>;

	return (
		<Select
			autoClearSearchValue
			className='multi-select-dropdown'
			filterOption={ caseInsensitiveContainsFilterOption }
			getPopupContainer={ getPopupContainer }
			mode='multiple'
			onChange={ setSelectedKeys }
			onDeselect={ () => confirm() }
			onOpenChange={ () => !visible && confirm() }
			options={ selectedKeys ? options : undefined }
			placeholder={ COPY_SPECIFIC.SELECT_USER }
			popupRender={ popupRender }
			showSearch
			value={ selectedKeys }
			variant='borderless' />
	);
};
